// extracted by mini-css-extract-plugin
export default {"scope_row":"ManegeUserScopeRow_scope_row__YGNDV","scope_delete":"ManegeUserScopeRow_scope_delete__wsuXF"};